export const VALID_GUESSES = [
  'аадар',
  'аажим',
  'аажуу',
  'аанай',
  'аахар',
  'аваар',
  'авагч',
  'аварь',
  'авгай',
  'авдар',
  'авлах',
  'аврал',
  'аврах',
  'автах',
  'автор',
  'агаар',
  'агент',
  'аглаг',
  'агнах',
  'агсам',
  'агсан',
  'агтач',
  'агчих',
  'агшин',
  'агших',
  'адгах',
  'адгуу',
  'адрес',
  'адтай',
  'адууч',
  'ажигч',
  'ажлын',
  'ажнай',
  'азаар',
  'азгүй',
  'азийн',
  'азтай',
  'айвуу',
  'айдас',
  'айзам',
  'аймаг',
  'айсан',
  'айсуй',
  'айсуу',
  'алаан',
  'алагч',
  'албат',
  'алдаа',
  'алдал',
  'алдар',
  'алдах',
  'алирс',
  'алмай',
  'алмас',
  'алсад',
  'алсын',
  'алтан',
  'алхаа',
  'алхам',
  'алхах',
  'аль ч',
  'амаар',
  'амгай',
  'амжих',
  'аминч',
  'амины',
  'амлах',
  'амраг',
  'амрах',
  'амсар',
  'амсах',
  'ан ав',
  'анааш',
  'ангал',
  'ангид',
  'ангит',
  'англи',
  'ангол',
  'андуу',
  'анжис',
  'анкет',
  'анхны',
  'анчин',
  'аптек',
  'араас',
  'арвай',
  'арван',
  'арвин',
  'арвич',
  'аргал',
  'ардаг',
  'ардач',
  'ардын',
  'ариун',
  'арлын',
  'артер',
  'архаг',
  'архад',
  'архив',
  'арцах',
  'арчих',
  'асаах',
  'асагч',
  'асалт',
  'асгах',
  'асрах',
  'асуух',
  'атаач',
  'атгах',
  'атийх',
  'аугаа',
  'ахлах',
  'ахмад',
  'ач үр',
  'ачаар',
  'ачигч',
  'ачилт',
  'ачлал',
  'ачсан',
  'ачтай',
  'ачтан',
  'ашигч',
  'аюулт',
  'ая эв',
  'аягүй',
  'аялал',
  'аялах',
  'аялга',
  'аянга',
  'аятай',
  'багаж',
  'бадаг',
  'бадар',
  'бажга',
  'базах',
  'балаг',
  'балар',
  'балга',
  'балет',
  'банан',
  'банди',
  'бараа',
  'бараг',
  'барак',
  'барах',
  'бариа',
  'барив',
  'барий',
  'барил',
  'бариу',
  'барих',
  'барон',
  'барьц',
  'бас л',
  'басах',
  'батга',
  'бахим',
  'бахуу',
  'бачуу',
  'башир',
  'бетон',
  'библи',
  'бидэр',
  'биеэр',
  'бизон',
  'билет',
  'билүү',
  'билээ',
  'бином',
  'битүү',
  'бичиг',
  'бичил',
  'бичих',
  'бланк',
  'бодис',
  'бодит',
  'бодол',
  'бодон',
  'бодох',
  'болих',
  'болно',
  'болор',
  'болох',
  'болхи',
  'боогч',
  'боолт',
  'боолч',
  'боомт',
  'бороо',
  'босго',
  'босоо',
  'босох',
  'ботго',
  'бохир',
  'бөхөн',
  'бөхөх',
  'бугуй',
  'будаа',
  'будаг',
  'будан',
  'будах',
  'бузар',
  'булаг',
  'булай',
  'булан',
  'булах',
  'булга',
  'булиа',
  'булуу',
  'бумба',
  'бурам',
  'бурах',
  'буруу',
  'бусаг',
  'бусад',
  'бутас',
  'бутач',
  'буулт',
  'буфет',
  'бухал',
  'бухын',
  'буцах',
  'буянт',
  'буяны',
  'бүгэх',
  'бүдэг',
  'бүжиг',
  'бүжин',
  'бүйлс',
  'бүлэг',
  'бүлэх',
  'бүрий',
  'бүрэг',
  'бүрэн',
  'бүрэх',
  'бүрээ',
  'бүтэл',
  'бүтэн',
  'бүтэх',
  'бүтэц',
  'бүхэл',
  'бүхэн',
  'бүчих',
  'бэлэг',
  'бэлэн',
  'бядуу',
  'бялуу',
  'бясаа',
  'ваарч',
  'вагон',
  'вальс',
  'валют',
  'вирус',
  'виски',
  'вольт',
  'гааль',
  'гаанс',
  'гавал',
  'гавар',
  'гадаа',
  'гадар',
  'гадас',
  'гадил',
  'гадна',
  'гадны',
  'гажиг',
  'гажих',
  'гажуу',
  'газар',
  'галав',
  'галиг',
  'галуу',
  'галын',
  'ганга',
  'гараа',
  'гараж',
  'гарал',
  'гарам',
  'гарах',
  'гариг',
  'гаруй',
  'гарын',
  'гахай',
  'гацаа',
  'гацах',
  'гелий',
  'гижиг',
  'гилгэ',
  'гитар',
  'гичий',
  'гишүү',
  'гогод',
  'голио',
  'голох',
  'голын',
  'гольф',
  'гоньд',
  'гоонь',
  'горхи',
  'гөжих',
  'гөлөг',
  'гөрөх',
  'грамм',
  'гуанз',
  'губка',
  'гудам',
  'гудас',
  'гуйгч',
  'гуйлт',
  'гуниг',
  'гуних',
  'гурав',
  'гурил',
  'гутал',
  'гууль',
  'гуурс',
  'гүвээ',
  'гүгэл',
  'гүдэс',
  'гүйгч',
  'гүйлс',
  'гүйлт',
  'гүнээ',
  'гүрэн',
  'гэгээ',
  'гэдэс',
  'гэзэг',
  'гэлэн',
  'гэнэн',
  'гэнэт',
  'гэрэл',
  'гэрээ',
  'гэсэх',
  'гэтэл',
  'гэтэх',
  'гялба',
  'даага',
  'даалт',
  'даваа',
  'давав',
  'давах',
  'давуу',
  'дагах',
  'дагуу',
  'дадал',
  'дадар',
  'дайнч',
  'дайны',
  'дайрж',
  'далай',
  'далан',
  'далим',
  'далиу',
  'дамар',
  'дараа',
  'дарах',
  'дарга',
  'даруй',
  'даруу',
  'дархи',
  'дасах',
  'дахин',
  'дахих',
  'даяан',
  'даяар',
  'дебет',
  'декан',
  'диван',
  'дивиз',
  'динам',
  'догма',
  'догши',
  'долир',
  'долоо',
  'домбо',
  'домог',
  'донго',
  'донор',
  'дорго',
  'дорно',
  'дорой',
  'дороо',
  'дотно',
  'дотны',
  'дотор',
  'дохио',
  'дохих',
  'дөлөх',
  'дөнгө',
  'дөрөв',
  'дөрөө',
  'дөхөм',
  'дөхөх',
  'дугай',
  'дугуй',
  'дуран',
  'дурын',
  'дусал',
  'дусах',
  'дутах',
  'дутуу',
  'дууль',
  'дууны',
  'дуурь',
  'духны',
  'дүлий',
  'дүлэх',
  'дүрэм',
  'дүрэх',
  'дэвэх',
  'дэгээ',
  'дэлбэ',
  'дэлүү',
  'дэлэн',
  'дэмий',
  'дээрх',
  'еврей',
  'Европ',
  'европ',
  'ембүү',
  'ер нь',
  'ердөө',
  'ерийн',
  'ерөөл',
  'ерөөс',
  'ерөөх',
  'еэсус',
  'жавар',
  'жагаа',
  'Жагаа',
  'жалан',
  'жалга',
  'живаа',
  'живэв',
  'живэх',
  'жижиг',
  'жишиг',
  'жиших',
  'жишээ',
  'жодоо',
  'жодох',
  'жолоо',
  'жонон',
  'жороо',
  'жоуль',
  'жөтөө',
  'журам',
  'жүжиг',
  'жүчээ',
  'заагч',
  'заалт',
  'зааны',
  'заарь',
  'завод',
  'загас',
  'залаа',
  'залах',
  'залма',
  'залуу',
  'замаг',
  'замын',
  'занал',
  'занар',
  'занах',
  'занга',
  'зараа',
  'зарам',
  'зарах',
  'зарга',
  'зарим',
  'засаа',
  'засаг',
  'засал',
  'засах',
  'захиа',
  'захих',
  'захын',
  'заяах',
  'зовох',
  'зовхи',
  'зодох',
  'зожиг',
  'золио',
  'золих',
  'зоорь',
  'зориг',
  'зорих',
  'зорох',
  'зорхи',
  'зотон',
  'зохих',
  'зочид',
  'зочин',
  'зөгий',
  'зөөгч',
  'зөрөг',
  'зөрөө',
  'зөрөх',
  'зөрүү',
  'зугаа',
  'зулай',
  'зураг',
  'зурах',
  'зусар',
  'зутан',
  'зуугч',
  'зууны',
  'зүдүү',
  'зүлэг',
  'зүсэм',
  'зүсэх',
  'зүүлт',
  'зүүнш',
  'зүхэл',
  'зүхэх',
  'зүчээ',
  'зэрэг',
  'зэсэн',
  'зэтэр',
  'зэүүн',
  'зэхэх',
  'зээлж',
  'ив ил',
  'ивээл',
  'ивээх',
  'ид үе',
  'иддэг',
  'идрээ',
  'идтэй',
  'идүүр',
  'идэвх',
  'идэгч',
  'идээр',
  'илбэх',
  'илбэч',
  'илжиг',
  'иллэг',
  'илрэл',
  'илрэх',
  'илтэд',
  'илүүр',
  'илүүц',
  'илхэн',
  'илчүү',
  'илээч',
  'имрэх',
  'имтэй',
  'индүү',
  'индэр',
  'инжир',
  'инээд',
  'инээх',
  'ирвэс',
  'иргүй',
  'иргэн',
  'ирлэх',
  'ирмэг',
  'ирмэх',
  'иртэй',
  'ирэлт',
  'исгэх',
  'ислам',
  'иссэн',
  'исэлт',
  'итали',
  'Итали',
  'итгэл',
  'итгэх',
  'их ус',
  'ихдээ',
  'ихсэх',
  'ихэнх',
  'ихээр',
  'ичсэн',
  'ичээх',
  'ишлэл',
  'ишлэх',
  'кабин',
  'какао',
  'какоа',
  'калий',
  'канад',
  'капот',
  'карат',
  'катод',
  'квант',
  'кварц',
  'квинт',
  'кирил',
  'кокос',
  'комик',
  'комод',
  'конус',
  'кубын',
  'кулон',
  'купон',
  'лавай',
  'лаван',
  'лавир',
  'лаври',
  'лазан',
  'лазер',
  'лалар',
  'лалын',
  'ламын',
  'латин',
  'леван',
  'лимбэ',
  'лимфа',
  'лицей',
  'логик',
  'ломбо',
  'лотоо',
  'магад',
  'магма',
  'магни',
  'мадаг',
  'майга',
  'малын',
  'манаа',
  'манай',
  'манан',
  'манах',
  'марал',
  'мариа',
  'мария',
  'масло',
  'масон',
  'масса',
  'матар',
  'матах',
  'махир',
  'мацаг',
  'машид',
  'машин',
  'между',
  'мезон',
  'метан',
  'метил',
  'метро',
  'миний',
  'минут',
  'могой',
  'модны',
  'модон',
  'молор',
  'мотор',
  'мохоо',
  'мөнгө',
  'мөрий',
  'мөрөн',
  'мөсөн',
  'мөхөл',
  'мөхөх',
  'мөчид',
  'мөчир',
  'музей',
  'мурий',
  'муруй',
  'мутар',
  'мэдэл',
  'мэдэх',
  'мэдэц',
  'мэдээ',
  'мэнгэ',
  'мэргэ',
  'мэрэх',
  'мэшил',
  'мянга',
  'нагац',
  'надад',
  'нажид',
  'налах',
  'налуу',
  'намаа',
  'намаг',
  'намар',
  'намба',
  'наран',
  'нарны',
  'натри',
  'нахиа',
  'нахид',
  'нахиу',
  'начин',
  'нефть',
  'никто',
  'нисэх',
  'ногоо',
  'номер',
  'номой',
  'номын',
  'норох',
  'нохой',
  'ноцох',
  'нөгөө',
  'нөлөө',
  'нөмөр',
  'нөрөө',
  'нөхөд',
  'нөхөр',
  'нөхөх',
  'нугас',
  'нурам',
  'нурах',
  'нуруу',
  'нутаг',
  'нуувч',
  'нуулт',
  'нухах',
  'нухаш',
  'нүгэл',
  'нүдэх',
  'нүсэр',
  'нүүгч',
  'нүүлт',
  'нүүрс',
  'нэгэн',
  'нэмүү',
  'нэмэр',
  'нэмэх',
  'нэрэх',
  'нэхий',
  'нэхэх',
  'нээлт',
  'ня бо',
  'нялах',
  'нярав',
  'няцах',
  'оазис',
  'овгор',
  'овжин',
  'овлох',
  'овтой',
  'огцом',
  'оддын',
  'одонт',
  'одсон',
  'одтой',
  'ойгүй',
  'ойдог',
  'ойрын',
  'ойсон',
  'ойтой',
  'ойчих',
  'оксид',
  'октав',
  'олбог',
  'олгий',
  'олгой',
  'олгох',
  'олдох',
  'олжго',
  'ологч',
  'ололт',
  'олсон',
  'олуул',
  'онгод',
  'онгон',
  'онгох',
  'онгоц',
  'ондоо',
  'онолч',
  'оноох',
  'оосор',
  'оочих',
  'оргил',
  'оргих',
  'оргох',
  'ордер',
  'ордон',
  'орлох',
  'оройн',
  'оролт',
  'оромж',
  'оронд',
  'ороох',
  'орсон',
  'орхих',
  'орчил',
  'орчим',
  'орчин',
  'орчих',
  'оршил',
  'орших',
  'осдол',
  'отолт',
  'отряд',
  'отход',
  'охины',
  'очсон',
  'оюуны',
  'өвгөд',
  'өвгөн',
  'өвдөг',
  'өвдөх',
  'өвлөх',
  'өвөрт',
  'өвсөн',
  'өвчин',
  'өвчих',
  'өвчүү',
  'өгзөг',
  'өглөг',
  'өглөө',
  'өгөгч',
  'өгөмж',
  'өгөөш',
  'өгсөн',
  'өгсөх',
  'өдлөх',
  'өдөгч',
  'өдөлт',
  'өдөөл',
  'өдөөх',
  'өдсөн',
  'өлгий',
  'өлгөх',
  'өлмий',
  'өлсөх',
  'өлчир',
  'өмнөх',
  'өмнөш',
  'өмсөх',
  'өмхий',
  'өнгөн',
  'өнгөр',
  'өнгөт',
  'өнгөц',
  'өндөг',
  'өндөр',
  'өнөөх',
  'өнтэй',
  'өнцөг',
  'өнчин',
  'өөгүй',
  'өөдөө',
  'өөдөс',
  'өөлөх',
  'өөрөө',
  'өргө)',
  'өргөл',
  'өргөн',
  'өргөө',
  'өргөс',
  'өргөх',
  'өрнөд',
  'өрнөл',
  'өрөвч',
  'өрсөх',
  'өртөг',
  'өртөө',
  'өртөх',
  'өртэй',
  'өсвөр',
  'өсгий',
  'өсгөх',
  'өсөлт',
  'өссөн',
  'өстөн',
  'өстэй',
  'өтгөн',
  'өтгөс',
  'өтсөн',
  'өттэй',
  'өшсөн',
  'парад',
  'пенни',
  'питон',
  'плита',
  'погон',
  'полка',
  'польш',
  'пончо',
  'порци',
  'призм',
  'прусс',
  'пүрэв',
  'радар',
  'радий',
  'радио',
  'район',
  'ранчо',
  'рахит',
  'резин',
  'робот',
  'роман',
  'ромбо',
  'ромын',
  'ротор',
  'рояль',
  'рубль',
  'румын',
  'сааль',
  'саваа',
  'саван',
  'савар',
  'савах',
  'савхи',
  'сагаг',
  'садан',
  'садар',
  'сажиг',
  'салаа',
  'салай',
  'салан',
  'салат',
  'салах',
  'салст',
  'салхи',
  'самар',
  'санаа',
  'санал',
  'санах',
  'сарий',
  'сарны',
  'сарын',
  'сарьс',
  'сатин',
  'сахал',
  'сахил',
  'сахих',
  'сврох',
  'сдоох',
  'сенат',
  'сжлол',
  'сжлох',
  'сжтой',
  'сигар',
  'синус',
  'сироп',
  'склад',
  'совин',
  'согог',
  'согоо',
  'содон',
  'солио',
  'солир',
  'солих',
  'солох',
  'сонет',
  'сонин',
  'сонор',
  'сорви',
  'сорих',
  'сорох',
  'сорьц',
  'сохор',
  'сөлөр',
  'сөнөл',
  'сөнөх',
  'сөрөг',
  'сөрөх',
  'сөрүү',
  'сөхөх',
  'спирт',
  'спорт',
  'среди',
  'срлох',
  'сроол',
  'сртой',
  'ссгүй',
  'сслол',
  'сслох',
  'ссоор',
  'сстой',
  'станц',
  'степь',
  'стиль',
  'студи',
  'суваг',
  'сувай',
  'сугар',
  'судаг',
  'судал',
  'судар',
  'судас',
  'суман',
  'сунал',
  'сунах',
  'сураг',
  'сурах',
  'суугч',
  'суурь',
  'сүжиг',
  'сүмбэ',
  'сүрэг',
  'сүрэл',
  'сүсэг',
  'сүүлд',
  'сэвэх',
  'сэдэв',
  'сэдэх',
  'сэжиг',
  'сэжих',
  'сэлт/',
  'сэлэм',
  'сэлэх',
  'сэрэл',
  'сэрэх',
  'сэрээ',
  'сэхээ',
  'таваг',
  'тавал',
  'тавил',
  'тавих',
  'тайга',
  'также',
  'такси',
  'талах',
  'талон',
  'талст',
  'тальк',
  'тамга',
  'тамир',
  'тамхи',
  'тамын',
  'танай',
  'танар',
  'танах',
  'танил',
  'таних',
  'танхи',
  'таных',
  'тарах',
  'тарга',
  'тариа',
  'тариф',
  'тарих',
  'тарни',
  'таруу',
  'тархи',
  'тасаг',
  'тасам',
  'татах',
  'таташ',
  'тахал',
  'тахиа',
  'тахил',
  'тахир',
  'тахих',
  'тачир',
  'ташаа',
  'ташуу',
  'театр',
  'текст',
  'тенор',
  'тиймд',
  'титан',
  'титэм',
  'тогоо',
  'тогос',
  'тоймч',
  'толбо',
  'тольт',
  'томат',
  'томох',
  'томуу',
  'тонна',
  'тоног',
  'тонох',
  'тооны',
  'торго',
  'торой',
  'торон',
  'тотго',
  'тотем',
  'тохой',
  'тохох',
  'тохуу',
  'төвөг',
  'төвөн',
  'төгөл',
  'төдий',
  'төлөв',
  'төлөө',
  'төлөх',
  'төмөр',
  'төрөл',
  'төрөх',
  'төсөв',
  'төсөл',
  'төсөө',
  'төсөр',
  'төхөл',
  'төхөм',
  'труба',
  'тугал',
  'тулах',
  'тулга',
  'тунах',
  'тунис',
  'туних',
  'турах',
  'тусах',
  'тусла',
  'тутам',
  'туугч',
  'тууль',
  'туурь',
  'туфли',
  'тухай',
  'тушаа',
  'туших',
  'туяа)',
  'түгэх',
  'түлэх',
  'түлээ',
  'түрэг',
  'түрэх',
  'түүнд',
  'түүхт',
  'түүхч',
  'түшиг',
  'түших',
  'тэвнэ',
  'тэвэр',
  'тэгнэ',
  'тэлэх',
  'тэлээ',
  'тэмээ',
  'тэнэг',
  'тэнэх',
  'тэрэг',
  'тэсвр',
  'тэсэл',
  'тэсэх',
  'тээгч',
  'увдис',
  'уг нь',
  'уг эх',
  'угаал',
  'угаах',
  'угалз',
  'угжих',
  'угийн',
  'углах',
  'угсаа',
  'угтаа',
  'угтах',
  'удаан',
  'удаах',
  'удган',
  'удмын',
  'удсан',
  'уйдам',
  'уйдах',
  'уйлах',
  'уйтан',
  'улаан',
  'улавч',
  'улайх',
  'улбаа',
  'улбар',
  'улдах',
  'улиас',
  'улигт',
  'уллах',
  'улсын',
  'умайх',
  'умард',
  'унага',
  'унагч',
  'уналт',
  'унгас',
  'ундаа',
  'ундны',
  'унжих',
  'униар',
  'унтаа',
  'унтав',
  'унтах',
  'унтуу',
  'унших',
  'урагш',
  'ураны',
  'урвал',
  'урвах',
  'урвуу',
  'ургах',
  'ургац',
  'ургүй',
  'урдах',
  'урлаг',
  'урлан',
  'урсах',
  'уртай',
  'уруул',
  'уршиг',
  'усгах',
  'усгүй',
  'услаг',
  'услах',
  'устах',
  'усчин',
  'утгах',
  'утсан',
  'ууган',
  'уугих',
  'уудам',
  'уудла',
  'уужим',
  'уужуу',
  'уулга',
  'уураг',
  'уурга',
  'уурын',
  'уусах',
  'уухай',
  'уушги',
  'уушиг',
  'ухаан',
  'ухагч',
  'ухалт',
  'ухрах',
  'уцаар',
  'учрал',
  'учрах',
  'уяман',
  'уянга',
  'уярал',
  'уярах',
  'уяхан',
  'үггүй',
  'үгзүй',
  'үгийн',
  'үглэл',
  'үглэх',
  'үглээ',
  'үдлэг',
  'үдээс',
  'үе үе',
  'үеийн',
  'үелэл',
  'үелэх',
  'үелээ',
  'үетэй',
  'үетэх',
  'үзвэл',
  'үзвэр',
  'үзлэг',
  'үзүүр',
  'үзэгч',
  'үзэмж',
  'үймэн',
  'үймэх',
  'үйрэх',
  'үлгэр',
  'үлдэл',
  'үлдэх',
  'үлдэц',
  'үлэмж',
  'үлээх',
  'үмбүү',
  'үмхэх',
  'үнгэх',
  'үндэс',
  'үнсэх',
  'үнэнч',
  'үнэр)',
  'үргүй',
  'үргэх',
  'үржил',
  'үржих',
  'үрлэг',
  'үрлэх',
  'үртэс',
  'үрэлт',
  'үрээр',
  'үсгүй',
  'үслэг',
  'үсрэх',
  'үстэй',
  'үсчин',
  'үсчих',
  'үтрээ',
  'үүдэх',
  'үүний',
  'үүрэг',
  'үүрэх',
  'үүсэл',
  'үүсэх',
  'үхдэл',
  'үхжил',
  'үхмэл',
  'үхсэн',
  'үхтэл',
  'физик',
  'фильм',
  'фокус',
  'фонем',
  'франк',
  'Франц',
  'франц',
  'хаа ч',
  'хаалт',
  'хаана',
  'хааны',
  'хааяа',
  'хавар',
  'хавах',
  'хавьд',
  'хагас',
  'хадан',
  'хадах',
  'хадир',
  'хажиг',
  'хажих',
  'хажуу',
  'хазах',
  'хаишр',
  'хайлш',
  'хайрс',
  'хайрт',
  'халаа',
  'халах',
  'халив',
  'халил',
  'халим',
  'халиу',
  'халих',
  'халйу',
  'хальс',
  'хальт',
  'хамаа',
  'хамар',
  'хамах',
  'хамба',
  'хамуу',
  'ханал',
  'ханах',
  'ханын',
  'хараа',
  'харах',
  'хариг',
  'харин',
  'хариу',
  'харих',
  'харуй',
  'харуу',
  'хасах',
  'хатан',
  'хатах',
  'хатиг',
  'хатир',
  'хатуу',
  'хахах',
  'хахир',
  'хацар',
  'хачиг',
  'хачин',
  'хачир',
  'хашаа',
  'хашин',
  'хашир',
  'хаших',
  'хаялт',
  'херес',
  'хивэг',
  'хивэн',
  'хивэх',
  'хижиг',
  'хийгч',
  'хийлч',
  'хилэн',
  'химич',
  'хинин',
  'хишиг',
  'хлорт',
  'ховил',
  'ховоо',
  'ховор',
  'хожил',
  'хожим',
  'хожих',
  'хожоо',
  'хожуу',
  'хойно',
  'холих',
  'холын',
  'хольц',
  'хонго',
  'хоног',
  'хонох',
  'хорго',
  'хориг',
  'хорин',
  'хорио',
  'хорих',
  'хором',
  'хорон',
  'хороо',
  'хорох',
  'хосул',
  'хотын',
  'хошин',
  'хошуу',
  'хөвөн',
  'хөвөө',
  'хөвөх',
  'хөдөө',
  'хөзөр',
  'хөнөг',
  'хөөгч',
  'хөөлт',
  'хөрөг',
  'хөрөө',
  'хөрөх',
  'хөсөг',
  'хөтөл',
  'хөтөч',
  'хөхөл',
  'хөхөө',
  'хөхөх',
  'хөшиг',
  'хөших',
  'хөшөө',
  'хуван',
  'хувин',
  'худаг',
  'худал',
  'худул',
  'хужир',
  'хулуу',
  'хумих',
  'хумхи',
  'хунар',
  'хуних',
  'хурал',
  'хурах',
  'хурга',
  'хурим',
  'хуруу',
  'хусан',
  'хусах',
  'хутга',
  'хууль',
  'хуурс',
  'хуурч',
  'хуцах',
  'хучих',
  'хушга',
  'хушуу',
  'хуягт',
  'хүдэр',
  'хүзүү',
  'хүлэр',
  'хүлэх',
  'хүний',
  'хүрнэ',
  'хүрэл',
  'хүрэм',
  'хүрэн',
  'хүрэх',
  'хүрээ',
  'хүсэл',
  'хүсэх',
  'хүхэр',
  'хүчил',
  'хүчир',
  'хүчит',
  'хэвэг',
  'хэвэл',
  'хэдий',
  'хэдэн',
  'хэдэр',
  'хэзээ',
  'хэлэх',
  'хэн ч',
  'хэний',
  'хэнээ',
  'хэрэв',
  'хэрэг',
  'хэрэм',
  'хэрэх',
  'хэрээ',
  'хэсэг',
  'хэсэх',
  'хэцүү',
  'хядах',
  'хянах',
  'хянга',
  'хяруу',
  'хясаа',
  'хясах',
  'хятад',
  'хяхах',
  'цаана',
  'цавуу',
  'цагаа',
  'цадах',
  'цадиг',
  'цалин',
  'царай',
  'царил',
  'цасан',
  'цахим',
  'цацаг',
  'цацар',
  'цацах',
  'циник',
  'цовоо',
  'цогих',
  'цомог',
  'цорго',
  'цорын',
  'цохио',
  'цохих',
  'цохох',
  'цочих',
  'цөлөх',
  'цөөнх',
  'цөөрс',
  'цөхөх',
  'цуваа',
  'цувих',
  'цусан',
  'цусны',
  'цууны',
  'цуцал',
  'цуцах',
  'цыган',
  'цэвэр',
  'цэмбэ',
  'цэнэг',
  'цэрэг',
  'цэхэр',
  'цэцэг',
  'цэцэн',
  'чавга',
  'чадал',
  'чадах',
  'чамин',
  'чанад',
  'чанар',
  'чанах',
  'чанга',
  'чарга',
  'чацуу',
  'чийрс',
  'чилэх',
  'чимэг',
  'чимэх',
  'чимээ',
  'чиний',
  'чирэх',
  'чихэр',
  'чихэх',
  'чичих',
  'чонын',
  'чөдөр',
  'чөлөө',
  'чөмөг',
  'чулуу',
  'чухал',
  'чухам',
  'шавар',
  'шавах',
  'шавга',
  'шавьж',
  'шагай',
  'шадар',
  'шажин',
  'шалах',
  'шалиг',
  'шанаа',
  'шарах',
  'шарга',
  'шарил',
  'шатар',
  'шатах',
  'шахах',
  'шахуу',
  'шашин',
  'шашны',
  'шериф',
  'шивэх',
  'шивээ',
  'шигүү',
  'шидэх',
  'шижир',
  'шилбэ',
  'шилэн',
  'шилэх',
  'шимэх',
  'шинэс',
  'ширэг',
  'ширэм',
  'ширээ',
  'шифер',
  'шорон',
  'шороо',
  'шохой',
  'шошго',
  'шөвөг',
  'шприц',
  'шрифт',
  'шстка',
  'шувуу',
  'шугам',
  'шугуй',
  'шулам',
  'шулах',
  'шунаг',
  'шунал',
  'шунах',
  'шураг',
  'шүгэл',
  'шүлэг',
  'шүрэн',
  'шүтэх',
  'шүүгч',
  'шүүлт',
  'шүүмж',
  'шүхэл',
  'шүхэр',
  'эвгүй',
  'эвдэх',
  'эвлэл',
  'эвсэл',
  'эвсэх',
  'эвтэй',
  'эвхэх',
  'эгдүү',
  'эгнээ',
  'эгшиг',
  'эгших',
  'эд юм',
  'эдгэх',
  'эдлэл',
  'эдлэн',
  'эдлэх',
  'эерэг',
  'эзгүй',
  'эзлэх',
  'экран',
  'элбэг',
  'элдэв',
  'элдэх',
  'элжиг',
  'элсэн',
  'элсэх',
  'элчин',
  'элэнц',
  'элээх',
  'эмгэг',
  'эмгэн',
  'эмзэг',
  'эмийн',
  'эмнэг',
  'эмнэх',
  'эмсэг',
  'эмээл',
  'эмээх',
  'энгүй',
  'энгэр',
  'эндүү',
  'эндэл',
  'эндэх',
  'эндээ',
  'эр эм',
  'эргүү',
  'эргэх',
  'эрдүү',
  'эрдэм',
  'эрдэс',
  'эржин',
  'эрлэг',
  'эрмэг',
  'эрүүл',
  'эрхэм',
  'эрчим',
  'эршүү',
  'эрэлт',
  'эрээн',
  'эсвэл',
  'эсгий',
  'эсгэл',
  'эсгэх',
  'эскиз',
  'эсрэг',
  'Этиоп',
  'этиоп',
  'эхгүй',
  'эхийн',
  'эхлэл',
  'эхлэх',
  'эхний',
  'эхнэр',
  'эхүүн',
  'эцсэн',
  'эцэст',
  'эцээх',
  'ээдэм',
  'ээдэх',
  'ээмэг',
  'ээрэх',
  'юмбүү',
  'юмгүй',
  'юмтай',
  'юүдэн',
  'юүлэх',
  'яамны',
  'яарал',
  'яарах',
  'яаруу',
  'явган',
  'явдал',
  'явсан',
  'явцад',
  'явцуу',
  'явшир',
  'ягаан',
  'ядмаг',
  'ядрал',
  'ядрам',
  'ядрах',
  'ядруу',
  'ялагч',
  'ялалт',
  'ялгаа',
  'ялгах',
  'ялдаа',
  'ялдам',
  'яллах',
  'ялсан',
  'ялтай',
  'ялтан',
  'ялтас',
  'ямаан',
  'ямагт',
  'ямарч',
  'янагш',
  'яндан',
  'янхан',
  'яншаа',
  'янших',
  'яншуй',
  'японы',
  'яр ур',
  'яралж',
  'ярвиг',
  'яргуй',
  'ярдаг',
  'яртай',
  'яртах',
  'яршиг',
  'ясжих',
  'ястай',
  'ястан',
  'ятгах',
  'яхдах',
]
